import { activityHistoryHandlers } from '@hems/util/src/mocks/handlers/activityHistoryHandlers';
import { alarmHandlers } from '@hems/util/src/mocks/handlers/alarmHandlers';
import { authHandlers } from '@hems/util/src/mocks/handlers/authHandler';
import { controlHandlers } from '@hems/util/src/mocks/handlers/controlHandlers';
import { deviceHandlers } from '@hems/util/src/mocks/handlers/deviceHandlers';
import { historyHandlers } from '@hems/util/src/mocks/handlers/historyHandlers';
import { siteHandlers } from '@hems/util/src/mocks/handlers/siteHandlers';
const handlers = [
    ...historyHandlers,
    ...alarmHandlers,
    ...deviceHandlers,
    ...controlHandlers,
    ...authHandlers,
    ...activityHistoryHandlers,
    ...siteHandlers,
];
export default handlers;
